import type { IAuthAdapter } from './types'
import type { ApiResponse } from '@/types/api'
import type {
  LoginCredentials,
  LoginResponse,
  PhoneLoginCredentials,
  RegisterCredentials,
  RegisterResponse,
  TokenInfo,
  UserInfo,
} from '@/types/auth'
import { authApi } from '@/api/auth'

export class AuthApiAdapter implements IAuthAdapter {
  async login(credentials: LoginCredentials): Promise<ApiResponse<LoginResponse>> {
    return authApi.login(credentials)
  }

  async phoneLogin(credentials: PhoneLoginCredentials): Promise<ApiResponse<LoginResponse>> {
    return authApi.phoneLogin(credentials)
  }

  async register(credentials: RegisterCredentials): Promise<ApiResponse<RegisterResponse>> {
    return authApi.register(credentials)
  }

  async refreshToken(refreshToken: string): Promise<ApiResponse<TokenInfo>> {
    return authApi.refreshToken(refreshToken)
  }

  async logout(): Promise<ApiResponse<void>> {
    return authApi.logout()
  }

  async getCurrentUser(): Promise<ApiResponse<UserInfo>> {
    return authApi.getCurrentUser()
  }
}
